import { zeroPad } from './number';

/**
 * Formats time in "mm:ss" format
 */
export const formatShortDuration = (milliseconds: number): string => {
  const minutes = Math.floor(milliseconds / (60 * 1000)) % 60;
  const seconds = Math.floor(milliseconds / 1000) % 60;

  return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
};

export interface DurationOptions {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

/**
 * Returns milliseconds representation of declarative duration object (days/hours/minutes/seconds)
 */
export const getDurationInMilliseconds = (options: DurationOptions): number => {
  let time = 0;

  if (options.days) {
    time += options.days * 24 * 60 * 60 * 1000;
  }

  if (options.hours) {
    time += options.hours * 60 * 60 * 1000;
  }

  if (options.minutes) {
    time += options.minutes * 60 * 1000;
  }

  if (options.seconds) {
    time += options.seconds * 1000;
  }

  return time;
};

export const epoch = () => Math.floor(Date.now() / 1000);
